<template>
	<div class="pane" :class="app.viewlayer" v-if="app.module_foncier || true">
		<div class="content" id="sidebarFoncier">
            <div class="sidebar-content">
                <!-- Sélecteur de parcelles avec bouton intégré -->
				<div style="margin-bottom:10px; display:flex; width: 100%;justify-content: center;">
					<a target="_blank" href="https://forms.office.com/Pages/ResponsePage.aspx?id=2OG_tqr2AUeDPisZlf0ZvZEbixUjiJ5JiwJ1Iq65w1JUQTJWOENLWEZXTDBFSkdDQktMTE5CS0xITC4u">
						<button class="btn-badge">
							<svg class="icon" viewBox="0 0 24 24">
								<path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"></path>
							</svg>
							Donnez votre avis
						</button>
					</a>
				</div>


                <div class="parcel-selector">
                    <div class="selector-header">
                        <div class="selector-title">Parcelle analysée</div>
						<div v-if="!app.loading_foncier">

							<a target="_blank" v-if="app.parcelle_infos.fiche_parcelle" :href="app.parcelle_infos.fiche_parcelle">
								<button class="plu-doc-btn" title="Fiche parcelle">
									<span class="material-symbols-outlined" style="font-size: 12px;">file_open</span>
									Fiche parcelle
								</button>
							</a>

						</div>
                    </div>
                    <div class="parcel-list">
                        <div class="parcel-chip selected">{{ app.parcelle.reference }}</div>
                    </div>
					<div class="parcel-count"  v-if="!app.loading_foncier">
						<div style="font-weight: 600; margin-bottom: 3px;">1 parcelle sélectionnée • {{ formatSurfacem(app.parcelle.surface)}}</div>
						<!--
						<div style="font-size: 10px; color: #6c5ce7; display: flex; align-items: center; gap: 4px;">
							<span class="material-icons" style="font-size: 12px;">touch_app</span>
							Cliquez sur la carte pour sélectionner d'autres parcelles
						</div>
						-->
					</div>
				</div>
				<div v-if="app.loading_foncier" style="height:400px">
					<div class="infinite-loader" style="width: 100%;display: flex;justify-content: center;padding-left: 30px;">
						<div class="loader"><icon file="loader" :size="64" style="color:#333" /></div>
					</div>
				</div>



                <!-- Zone PLU avec accès documents -->
                <div class="plu-card" v-if="!app.loading_foncier" style="opacity: 1; transform: translateX(0px); transition: 0.4s;">
                    <div class="plu-header">
                        <div class="plu-title">
                            <!--<span class="material-icons">map</span>-->
                            Zonage PLU
                        </div>
                        <!-- <button class="plu-doc-btn" target="_blank" :ref="app.parcelle_zone_urbaine && app.parcelle_zone_urbaine.length && app.parcelle_zone_urbaine[0].properties.url" @click="openPLU(true)">-->
						<a target="_blank" :href="app.parcelle_zone_urbaine && app.parcelle_zone_urbaine.length && app.parcelle_zone_urbaine[0].properties.url">
							<button class="plu-doc-btn">
								<span class="material-symbols-outlined" style="font-size: 12px;">file_open</span>
								PLU
							</button>
						</a>
                    </div>
                    <div class="plu-zones" v-if="app.parcelle_zone_urbaine.length">
						<div class="zone-chip" style="width:100%">
							<table style="width:100%">
								<tr v-for="z in app.parcelle_zone_urbaine" :key="'zu_' + z.properties.cle_naturelle">
									<td style="width:25%"><div class="zone-code">{{ z.properties.libelle }}</div></td>
									<td><div class="zone-description">{{ z.properties.description }}</div></td>
								</tr>
							</table>
						</div>
                    </div>
                </div>
                
                <!-- Section Risques (accordéon) -->
                <div class="accordion-section" v-if="!app.loading_foncier">
                    <div class="accordion-header" @click="toggleAccordion($event)">
                        <div class="accordion-title">
                            Analyse des risques
                            <span class="accordion-count">{{ parcelle_risques_filtered().length }}</span> 
                        </div>
                        <span class="material-icons" style="transform: rotate(0deg);">expand_more</span>
                    </div>
                    <div class="accordion-content open">
							<div class="risk-scope-toggle" style="margin: 0px 0px 12px; opacity: 1; transform: translateX(0px); transition: 0.4s;">
                                <div class="scope-header">
                                    <div class="scope-info">
                                        <!--<div class="scope-label" id="risk-scope-label">Analyse • </div><div v-if="ChoixAdresseVille=='Adresse'">Adresse</div><div v-else>Commune</div>-->
                                        <div class="scope-label" id="scope-detail" v-if="ChoixAdresseVille=='Adresse'">{{ app.adr_init.name }}</div><div class="scope-label" v-else>{{ app.adr_init.city }}</div>
                                    </div>
                                    <button class="scope-toggle-btn" @click="toggleRiskScope()">
                                        <span class="material-icons" style="font-size: 10px;" id="toggle-icon">swap_horiz</span>
                                        <span id="toggle-text" v-if="ChoixAdresseVille=='Adresse'">Commune</span><span v-else>Adresse</span>
                                    </button>
                                </div>
                            </div>
<!--
							<div class="risk-summary" style="margin-bottom: 12px; padding: 8px;">
                                <div class="risk-stats" style="margin-bottom: 0;">
                                    <div class="stat-mini">
                                        <span class="stat-number" id="existants-count" style="font-size: 14px; transform: scale(1);">{{ risquesParClasse().present }}</span>
                                        <span class="stat-text">existants</span>
                                    </div>
                                    <div class="stat-mini">
                                        <span class="stat-number" id="faibles-count" style="font-size: 14px; transform: scale(1);">{{ risquesParClasse().faible }}</span>
                                        <span class="stat-text">faibles</span>
                                    </div>
                                    <div class="stat-mini">
                                        <span class="stat-number" id="concernes-count" style="font-size: 14px; transform: scale(1);">{{ risquesParClasse().existant }}</span>
                                        <span class="stat-text">concernés</span>
                                    </div>
                                </div>
                            </div>
-->
							<div class="risk-downloads">
								<a target="_blank" :href="app.parcelle_infos.url_risques_pdf">
									<button class="plu-doc-btn" title="Rapport Géorisques">
										<span class="material-symbols-outlined" style="font-size: 12px;">file_open</span>
										<span>Rapport Géorisques</span>
									</button>
								</a>
								<a target="_blank" v-if="app.parcelle_infos.dcrim && app.parcelle_infos.dcrim.data && app.parcelle_infos.dcrim.data.length" :href="app.parcelle_infos.dcrim.data[0].url_dcrim">
									<button class="plu-doc-btn" title="DICRIM communal">
										<span class="material-symbols-outlined" style="font-size: 12px;">file_open</span>
										<span>DICRIM</span>
									</button>
								</a>
								<!--
								<a target="_blank" :href="app.parcelle_infos.url_risques_pdf">
									<button class="download-compact" onclick="openGeorisques()" title="Voir sur Géorisques.gouv.fr">
										<span class="material-icons">open_in_new</span>
										<span>Source</span>
									</button>
								</a>
								-->
                            </div>						
                        <div class="risk-item-compact" :class="r.class" v-for="r in parcelle_risques_filtered()" :key="'risque_' + r.libelle">
                            <div class="risk-info-compact">
								<div class="risk-icon-compact"><span class="material-icons">{{ getIconForRisque(r.libelle) }}</span></div>
								<div class="risk-name-compact">{{ r.libelle }}</div>
                            </div>
                            <div class="risk-status-compact">{{ r.libelleStatutAdresse }}</div>
                        </div>
                    </div>
                </div>
                
                <!-- Section Bâtiments (accordéon) avec éléments cliquables -->
                <div class="accordion-section" v-if="!app.loading_foncier">
                    <div class="accordion-header" ref="bat" @click="toggleAccordion($event)">
                        <div class="accordion-title">
                            Bâtiments existants
                            <span class="accordion-count">{{ batiments_filtered().length }}</span>
                        </div>
                        <span class="material-icons" style="transform: rotate(0deg);">expand_more</span>
                    </div>
                    <div class="accordion-content">
                        <div class="accordion-section" v-for="b in batiments_filtered()" :key="'bat_' + b.batiment_groupe_id">
							<div class="accordion-header" @click="toggleAccordion2($event)">
								<div class="accordion-title" style="width:100%">
									<div class="building-icon">
										<span class="material-icons">{{ b.ico }}</span>
									</div>
									<div class="building-info">
										<div class="building-name">{{ b.libelle }}</div>
										<div class="building-details">{{ b.emprise_sol }} m² {{ b.construit }}</div>
									</div>
									<div v-if="b.diagnostics && b.diagnostics.length" class="dpe-badge" :class="'dpe-' + b.diagnostics[0].classe_consommation_energie" :title="'DPE : ' + b.diagnostics[0].classe_consommation_energie + ' - ' + Math.round(b.diagnostics[0].consommation_energie_finale_5_usages)  + 'kWh/m²/an'">{{ b.diagnostics[0].classe_consommation_energie }}</div>
									<div class="building-badge">BDNB</div>
								</div>
								<span class="material-icons2" v-if="b.diagnostics && b.diagnostics.length" style="transform: rotate(0deg);">expand_more</span>
							</div>

							<div class="accordion-content" style="background: #f5f6f9;" v-if="b.diagnostics && b.diagnostics.length" >
									<div class="building-details-content">
                                        <div class="building-detail-grid">
                                            <div class="building-detail-item">
                                                <div class="building-detail-label">Consommation</div>
                                                <div class="building-detail-value">{{  Math.round(b.diagnostics[0].consommation_energie_finale_5_usages) }} kWh/m²</div>
                                            </div>
                                            <div class="building-detail-item">
                                                <div class="building-detail-label">Émissions GES</div>
                                                <div class="building-detail-value">{{  Math.round(b.diagnostics[0].emission_ges_5_usages) }} kg CO2/m²</div>
                                            </div>
                                            <div class="building-detail-item">
                                                <div class="building-detail-label">Chauffage</div>
                                                <div class="building-detail-value">{{  b.diagnostics[0].chauffage_energie }} {{  b.diagnostics[0].chauffage_type_installation }}</div>
                                            </div>
                                            <div class="building-detail-item">
                                                <div class="building-detail-label">Isolation</div>
                                                <div class="building-detail-value">{{  b.diagnostics[0].mur_isolation_type }}</div>
                                            </div>
                                        </div>
										<!--
                                        <div class="building-info-text">
                                            <strong>Rénovation :</strong> Toiture refaite en 2018. Potentiel d'amélioration énergétique par isolation des murs.
                                        </div>
										-->
                                    </div>
							</div>
                        </div>
						<!---->
                        <div style="font-size: 11px; color: #6c757d; margin-top: 12px; padding: 8px; background: #f8f9fa; border-radius: 6px;" v-if="app.parcelle.surface">
                            <strong>Emprise totale :</strong> {{ total_emprise_sol() }} m² ({{ Math.round(total_emprise_sol() / app.parcelle.surface * 100) }}% de la parcelle)<br>
                            <!--Cliquez sur un bâtiment pour voir les données BDNB-->
                        </div>
                    </div>
                </div>
                
                <!-- Informations cadastrales compactes -->
			<!---->
				<div class="cadastral-section" style="opacity: 1; transform: translateX(0px); transition: 0.4s;" v-if="!app.loading_foncier">
                    <div class="cadastral-header">
                        <div class="cadastral-title">
                            Propriétaires
							<span class="accordion-count" v-if="app.parcelle_infos.proprietaires.length>1">{{ app.parcelle_infos.proprietaires.length }}</span>
                        </div>
                    </div>
<!--
                    <div class="cadastral-refs">
                        <div class="ref-chip">AK 0123</div>
                        <div class="ref-chip">AK 0124</div>
                    </div>
-->                    
                    <div class="owners-summary">
                        <!--<strong>{{ app.parcelle_infos.proprietaires.length }} propriétaires :</strong><br>-->
						<span v-for="p in app.parcelle_infos.proprietaires" :key="'siren_' + p.siren"> {{ p.raison_sociale }}<br></span>
                    </div>
                </div>
				<!---->
                <!-- Section Prix en bas -->
				<!--
				<div class="cadastral-section" style="opacity: 1; transform: translateX(0px); transition: 0.4s;">
                    <div class="cadastral-header">
                        <div class="cadastral-title">
                            Données de marché
                        </div>
                    </div>
                    
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 12px;">
                        <div style="background: white; border: 1px solid #f8f9fa; border-radius: 8px; padding: 10px; text-align: center;">
                            <div style="font-size: 10px; color: #6c757d; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 500;">Prix Estimmo</div>
                            <div style="font-size: 14px; font-weight: 700; color: #343a40;">4 250 €<span style="font-size: 10px; color: #6c757d; margin-left: 2px;">/m²</span></div>
                        </div>
                        <div style="background: white; border: 1px solid #f8f9fa; border-radius: 8px; padding: 10px; text-align: center;">
                            <div style="font-size: 10px; color: #6c757d; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 500;">Prix DVF Secteur</div>
                            <div style="font-size: 14px; font-weight: 700; color: #343a40;">3 680 €<span style="font-size: 10px; color: #6c757d; margin-left: 2px;">/m²</span></div>
                        </div>
                    </div>
                    
                    <div style="margin-bottom: 8px;">
                        <div style="font-size: 11px; font-weight: 600; color: #343a40; margin-bottom: 6px;">Transactions sur les parcelles</div>
                        
                        <div style="background: white; border: 1px solid #f8f9fa; border-radius: 6px; padding: 8px; margin-bottom: 6px;">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 3px;">
                                <div style="font-size: 10px; font-weight: 600; color: #343a40;">AK 0123 • 15/03/2019</div>
                                <div style="font-size: 9px; color: #6c757d; background: #f8f9fa; padding: 2px 4px; border-radius: 3px;">Maison</div>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; font-size: 10px;">
                                <div style="text-align: center;">
                                    <div style="color: #6c757d; font-size: 8px;">Prix</div>
                                    <div style="font-weight: 600; color: #343a40;">485 000 €</div>
                                </div>
                                <div style="text-align: center;">
                                    <div style="color: #6c757d; font-size: 8px;">Surface</div>
                                    <div style="font-weight: 600; color: #343a40;">135 m²</div>
                                </div>
                                <div style="text-align: center;">
                                    <div style="color: #6c757d; font-size: 8px;">Prix/m²</div>
                                    <div style="font-weight: 600; color: #6c5ce7;">3 593 €</div>
                                </div>
                            </div>
                        </div>
                        
                        <div style="background: white; border: 1px solid #f8f9fa; border-radius: 6px; padding: 8px;">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 3px;">
                                <div style="font-size: 10px; font-weight: 600; color: #343a40;">AK 0124 • 28/11/2021</div>
                                <div style="font-size: 9px; color: #6c757d; background: #f8f9fa; padding: 2px 4px; border-radius: 3px;">Terrain</div>
                            </div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; font-size: 10px;">
                                <div style="text-align: center;">
                                    <div style="color: #6c757d; font-size: 8px;">Prix</div>
                                    <div style="font-weight: 600; color: #343a40;">280 000 €</div>
                                </div>
                                <div style="text-align: center;">
                                    <div style="color: #6c757d; font-size: 8px;">Surface</div>
                                    <div style="font-weight: 600; color: #343a40;">860 m²</div>
                                </div>
                                <div style="text-align: center;">
                                    <div style="color: #6c757d; font-size: 8px;">Prix/m²</div>
                                    <div style="font-weight: 600; color: #6c5ce7;">326 €</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div style="font-size: 9px; color: #6c757d; text-align: center; background: rgba(108, 92, 231, 0.05); padding: 4px 6px; border-radius: 4px;">
                        💡 Données DVF (Demandes de Valeurs Foncières)
                    </div>
                </div>
				-->
            </div>
        </div>		
	</div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
	name: 'PaneLayer',

	data () {
		return {
			ChoixAdresseVille : 'Adresse',
		}
	},

	watch: {
		/*
		// Watcher sur la propriété calculée "surfaces"
		surfaces(newSurfaces, oldSurfaces) {
			newSurfaces.forEach((surface, index) => {
				if (surface !== oldSurfaces[index]) {
					this.torefresh = true
				}
			});
		},
		*/
	},

	methods: {
		total_emprise_sol: function () {
			return this.app.parcelle_infos.batiments.reduce((sum, b) => {
				return sum + (parseFloat(b.emprise_sol) || 0)
			}, 0)
		},

		batiments_filtered: function() {
			let t = []
			for (let index = 0; index < this.app.parcelle_infos.batiments.length; index++) {
				const element = this.app.parcelle_infos.batiments[index];
				switch (element.usage) {
					case 'Résidentiel individuel':
							element.ico = 'home'
							element.libelle = 'Maison individuelle'
						break;
					case 'Résidentiel collectif':
							element.ico = 'business'
							element.libelle = 'Bâtiment résidentiel'
						break;
				
					default:
							element.ico = 'warehouse'
							element.libelle = 'Annexe'
						break;
				}
				if (element.annee_construction_min == element.annee_construction_max) {
					if (element.annee_construction_max != null) element.construit = ' • Construit en ' + element.annee_construction_max
					else element.construit = ''
				} else {
					if (element.annee_construction_min!= null && element.annee_construction_max != null) element.construit = ' • Construit entre ' + element.annee_construction_min + ' et ' + element.annee_construction_max
					else {
						if (element.annee_construction_min!= null) element.construit = ' • Construit aprés ' + element.annee_construction_min
						else  element.construit = ' • Construit avant ' + element.annee_construction_max
					}
				}
				t.push(element)
			}
			return t;
		},
		parcelle_risques_filtered: function() {
			const risques = this.app.parcelle_infos?.lst_risques || {};
			const types = ['risquesNaturels', 'risquesTechnologiques'];
			let resultat = [];

			types.forEach(type => {
				const bloc = risques[type] || {};
				Object.values(bloc).forEach(risque => {
					if (risque?.libelle) {
						let l = 'libelleStatutAdresse'
						if (this.ChoixAdresseVille == 'Ville') { l = 'libelleStatutCommune' }
						let a = risque[l] ? risque[l].replace(/risque/gi, '').replace('Existant - ', '').trim() : null
						a = this.capitalizeFirstLetter(a)
						resultat.push({
							libelle: risque.libelle,
							class: this.getClassForRisque(a),
							order: this.getOrderForRisque(a),
							libelleStatutAdresse: a
						});
					}
				});
			});

			resultat.sort((a, b) => a.order - b.order);

			return resultat;
		},

		risquesParClasse: function() {
			const classes = {
				present: 0,
				faible: 0,
				existant: 0,
				inconnu: 0
			};

			this.parcelle_risques_filtered().forEach(risque => {
				if (Object.prototype.hasOwnProperty.call(classes, risque.class)) {
					classes[risque.class]++;
				} else {
					classes[risque.class] = 1;
				}
			});

			return classes;
		},

		getIconForRisque(libelle) {
			const mapping = {
			'Inondation': 'water_drop',
			'Remontée de nappe': 'opacity',
			'Risques côtiers (submersion marine, tsunami)': 'waves',
			'Séisme': 'landslide',
			'Retrait gonflement des argiles': 'trip_origin',
			'Feu de foret': 'local_fire_department',
			'Radon': 'science',
			'Avalanche': 'landslide',
			'Pollution des sols': 'water_voc',
			'Canalisations de transport de matières dangereuses': 'local_gas_station',
			'Installations industrielles classées (ICPE)': 'factory',
			'Rupture de barrage': 'flood',
			'Nucléaire': 'nuclear',
			'Volcan': 'volcano',
			'Vent violant': 'air',
			'Risques miniers': 'crisis_alert'
			};

			// Retourne l'icône correspondante, ou un fallback
			return mapping[libelle] || 'report_problem';
		},
		getClassForRisque(libelle) {
			const mapping = {
				'Fort'		: 'present',
				'Important'	: 'present',
				'Présent'	: 'present',
				'Existant'	: 'present',
				'Concerne'	: 'present',
				'Modéré'	: 'modere',
				'Faible'	: 'faible',
				'Inconnu'	: 'inconnu',
			};

			// Retourne l'icône correspondante, ou un fallback
			return mapping[libelle] || 'report_problem';
		},
		getOrderForRisque(libelle) {
			const mapping = {
				'Fort'		: 0,
				'Important'	: 1,
				'Présent'	: 2,
				'Concerne'	: 3,
				'Existant'	: 4,
				'Modéré'	: 5,
				'Faible'	: 6,
				'Inconnu'	: 7,
			};

			// Retourne l'icône correspondante, ou un fallback
			return mapping[libelle] || 9;
		},
		openPLU(b) {
			this.$store.commit('SET_VALUE', {c: 'DialogMessageDocuments', v: b});
        },
		// Gestion des accordéons
		toggleRiskScope: function() {
			if (this.ChoixAdresseVille == 'Adresse') {
				this.ChoixAdresseVille = 'Ville'
			} else {
				this.ChoixAdresseVille = 'Adresse'
			}
		},
        toggleAccordion(event) {
			const header = event.currentTarget;
			const content = header.nextElementSibling;
			const icon = header.querySelector('.material-icons:last-child');

			if (content) {
				const isOpen = content.classList.toggle('open');

				// Dynamically set max-height
				//if (isOpen) {
				//	content.style.maxHeight = content.scrollHeight + "px";
				//} else {
				//	content.style.maxHeight = "0px";
				//}

				// Rotate the icon
				if (icon) {
					icon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
				}
			}
        },

        toggleAccordion2(event) {
			const header = event.currentTarget;
			const content = header.nextElementSibling;
			const icon = header.querySelector('.material-icons2:last-child');

			if (content) {
				const isOpen = content.classList.toggle('open');

				// Dynamically set max-height
				//if (isOpen) {
				//	content.style.maxHeight = content.scrollHeight + "px";
				//} else {
				//	content.style.maxHeight = "0px";
				//}

				// Rotate the icon
				if (icon) {
					icon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
				}
			}
        },

		formatSurfacem(value) {
			try {
				return value.toLocaleString('fr-FR', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + " m²";
			} catch (error) {
				return ""				
			}
		},

		capitalizeFirstLetter: function(str) {
			if (!str) return '';
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		},

	},

	mounted() {
	},

	
	computed: Object.assign(mapGetters([ 'app' ]), {

	}),

	components: {  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/app'

#programme_size
	width 50px

.loading-icon
	animation rotate 2s infinite linear
	margin 0 auto
.infinite-loader
	.loader
		display inline-block
		border none
		border-radius 100%
		.icon
			display block
			animation rotate 1.5s infinite linear


.sidebar-content {
	flex: 1;
	padding: 20px;
	overflow-y: auto;
}
.parcel-selector {
	background: #f8f9fa;
	border-radius: 12px;
	padding: 14px;
	margin-bottom: 16px;
}

.selector-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}

.selector-title {
	font-size: 13px;
	font-weight: 600;
	color: #343a40;
}

.parcel-count {
	font-size: 11px;
	color: #6c757d;
	background: white;
	padding: 4px 8px;
	border-radius: 8px;
	margin-top: 8px;
	text-align: center;
}

.parcel-list {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-bottom: 10px;
}

.parcel-chip {
	background: white;
	border: 1px solid #adb5bd;
	border-radius: 20px;
	padding: 4px 10px;
	font-size: 11px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	font-weight: 500;
}

.parcel-chip.selected {
	background: #6c5ce7;
	color: white;
	border-color: #6c5ce7;
}

.parcel-chip:hover {
	border-color: #6c5ce7;
	transform: translateY(-1px);
}

/* Informations PLU intégrées */

.plu-card {
    background: #ffffff;
    color: #343a40;
    border: 1px solid #e9ecef;
    margin: 0 0px 12px 0px;
    border-radius: 12px;
    padding: 12px;
}

.plu-zone-card {
	background: linear-gradient(135deg, #6c5ce7 0%, #5341d6 100%);
	border-radius: 12px;
	padding: 16px;
	margin-bottom: 16px;
	color: white;
	position: relative;
}

.plu-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
}

.plu-title {
	font-size: 13px;
	font-weight: 600;
	display: flex;
	align-items: center;
	gap: 8px;
}

.plu-doc-btn {
    background: #f8f9fa;
    color: #343a40;
    border: 1px solid #e9ecef;
    border-radius: 16px;
    padding: 4px 8px;
    font-size: 10px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    gap: 4px;
}

.plu-doc-btn2 {
	background: #f39c12;
	border: none;
	color: white;
	border-radius: 20px;
	padding: 4px 8px;
	font-size: 10px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.plu-doc-btn:hover {
	background: #a29bfe;
	color: white;
	border-color: #a29bfe;
}

.plu-zones {
    //display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.zone-chip {
	background: #f8f9fa;
    border-radius: 8px;
    padding: 8px;
    text-align: center;
}

.zone-code {
	font-size: 14px;
	font-weight: 700;
	margin-bottom: 2px;
	color: #6c5ce7;
}

.zone-description {
    font-size: 10px;
    color: #6c757d;
    line-height: 1.2;
}

/* Bâtiments cliquables */
.building-item {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px;
	margin-bottom: 6px;
	background: white;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	border: 1px solid #f8f9fa;
}

.building-item:hover {
	border-color: #6c5ce7;
	transform: translateX(4px);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.building-icon {
	font-size: 16px;
	color: #6c5ce7;
}

.building-info {
	flex: 1;
}

.building-name {
	font-size: 11px;
	font-weight: 600;
	color: #343a40;
	margin-bottom: 2px;
}

.building-details {
	font-size: 10px;
	color: #6c757d;
}
/*
.building-badge {
	background: #f8f9fa;
	color: #6c5ce7;
	font-size: 9px;
	padding: 2px 6px;
	border-radius: 4px;
	font-weight: 500;
}
*/
.building-badge {
    background: #6c5ce7;
    color: white;
    font-size: 8px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
}

/* Informations structurées */
.info-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px;
	margin-bottom: 16px;
}

.info-mini-card {
	background: white;
	border: 1px solid #f8f9fa;
	border-radius: 6px;
	padding: 8px;
	text-align: center;
}

.info-mini-label {
	font-size: 10px;
	color: #6c757d;
	margin-bottom: 2px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.info-mini-value {
	font-size: 12px;
	font-weight: 600;
	color: #343a40;
}

/* Section accordéon */
.accordion-section {
	border: 1px solid #f8f9fa;
	border-radius: 8px;
	margin-bottom: 12px;
	overflow: hidden;
}

.accordion-header {
	background: #f8f9fa;
	padding: 10px 12px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-header:hover {
	background: #e9ecef;
}

.accordion-title {
	font-size: 12px;
	font-weight: 600;
	color: #343a40;
	display: flex;
	align-items: center;
	gap: 6px;
}

.accordion-count {
	background: #6c5ce7;
	color: white;
	font-size: 10px;
	padding: 2px 6px;
	border-radius: 10px;
}

.accordion-content {
  background: white;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  box-sizing: border-box;
  padding: 0 12px; /* padding horizontal conservé */
  max-height: 0;
}

.accordion-content.open {
  /* pas de max-height fixe ici */
  padding: 12px;
  max-height: 1000px; /* ou un max arbitraire suffisamment grand */
}



*/
.risk-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	margin-bottom: 6px;
	border-radius: 8px;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.risk-item-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    margin-bottom: 6px;
    border-radius: 6px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-left: 2px solid #e9ecef;
    font-size: 11px;
    cursor: pointer;
    background: white;
    border: 1px solid #f8f9fa;
}
.risk-item-compact.existant {
    border-left-color: #6c5ce7;
}
.risk-item-compact.faible {
    border-left-color: #2c835c;
}
.risk-item-compact.modere {
    border-left-color: #745d50;
}
.risk-item-compact.present {
    border-left-color: #e74c3c;
}


.risk-item-compact.present .risk-status-compact {
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
}
.risk-item-compact.existant .risk-status-compact {
    background: rgba(108, 92, 231, 0.1);
    color: #6c5ce7;
}
.risk-item-compact.faible .risk-status-compact {
    background: #bbfdcd;
    color: #2c835c;
}
.risk-item-compact.modere .risk-status-compact {
    background: #fdebd2;
    color: #745d50;
}

.risk-item-compact.existant .risk-icon-compact {
    background: rgba(108, 92, 231, 0.1);
    color: #6c5ce7;
}
.risk-item-compact.faible .risk-icon-compact {
    background: #bbfdcd;
    color: #2c835c;
}
.risk-item-compact.present .risk-icon-compact {
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
}
.risk-item-compact.modere .risk-icon-compact {
    background: #fdebd2;
    color: #745d50;
}

.risk-info-compact {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}
.risk-icon-compact {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    flex-shrink: 0;
    background: #f8f9fa;
    color: #6c757d;
}
.risk-name-compact {
    font-weight: 500;
    color: #343a40;
    line-height: 1.2;
}


.risk-status-compact {
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 9px;
    font-weight: 500;
    background: #f8f9fa;
    color: #6c757d;
}


.risk-item.safe {
	background: #f8f9fa;
	border: 1px solid #f8f9fa;
}

.risk-item.alert {
	background: rgba(243, 156, 18, 0.1);
	border: 2px solid #f39c12;
	animation: alertPulse 2s infinite;
}

.risk-name {
	font-size: 12px;
	font-weight: 500;
	color: #343a40;
	display: flex;
	align-items: center;
	gap: 8px;
}

.risk-icon {
	font-size: 16px;
	color: #6c757d;
}

.risk-item.alert .risk-icon {
	color: #f39c12;
}

.risk-status {
	padding: 4px 8px;
	border-radius: 12px;
	font-size: 10px;
	font-weight: 600;
	//text-transform: uppercase;
	letter-spacing: 0.5px;
}

.risk-status.safe {
	background: #e9ecef;
	color: #6c757d;
}

.risk-status.alert {
	background: #f39c12;
	color: white;
}

/* Contrôles de zoom */
.zoom-controls {
	position: absolute;
	bottom: 20px;
	right: 20px;
	z-index: 100;
}


/* Informations cadastrales compactes */
.cadastral-summary {
	background: #f8f9fa;
	border-radius: 12px;
	padding: 12px;
	margin-bottom: 16px;
}

.cadastral-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}

.cadastral-title {
font-size: 13px;
    font-weight: 600;
    color: #343a40;
    display: flex;
    align-items: center;
    gap: 6px;
}

.cadastral-refs {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-bottom: 8px;
}

.ref-chip {
	background: white;
	border: 1px solid #a29bfe;
	border-radius: 10px;
	padding: 3px 8px;
	font-size: 10px;
	color: #6c5ce7;
	font-weight: 600;
}

.owners-summary {
	font-size: 11px;
	color: #6c757d;
	line-height: 1.3;
}

/* Section prix */
.price-section {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border-radius: 12px;
	padding: 16px;
	margin-bottom: 16px;
	color: white;
}

.price-header {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;
}

.price-title {
	font-size: 13px;
	font-weight: 600;
}

.price-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px;
}

.price-item {
	background: rgba(255, 255, 255, 0.15);
	border-radius: 8px;
	padding: 8px;
	text-align: center;
	backdrop-filter: blur(10px);
}

.price-label {
	font-size: 10px;
	opacity: 0.9;
	margin-bottom: 2px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.price-value {
	font-size: 13px;
	font-weight: 700;
}

.price-unit {
	font-size: 9px;
	opacity: 0.8;
}

.risk-downloads {
    display: flex;
	justify-content: space-between;
    gap: 4px;
    margin-bottom: 12px;
}

.download-compact {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 9px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    color: #6c757d;
}

.download-compact:hover {
	background: #a29bfe;
	color: white;
}

.risk-scope-toggle {
    background: rgba(108, 92, 231, 0.05);
    padding: 8px 12px;
    border-radius: 8px;
    margin: 0 16px 12px 16px;
    border-left: 3px solid #6c5ce7;
}
.scope-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.scope-info {
    flex: 1;
}
.scope-label {
    font-size: 11px;
    font-weight: 600;
    color: #343a40;
    margin-bottom: 2px;
}
.scope-detail {
    font-size: 9px;
    color: #6c757d;
}
.scope-toggle-btn {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 4px 8px;
    font-size: 8px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    color: #343a40;
    display: flex;
    align-items: center;
    gap: 3px;
}
.scope-toggle-btn:hover {
    background: #6c5ce7;
    border-color: #6c5ce7;
	color: white;
}
.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.material-icons-outlined {
    font-family: 'Material Icons Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.material-symbols-outlined {
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}

.material-icons2 {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.risk-summary {
    background: #f8f9fa;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 12px;
    border-left: 3px solid #6c5ce7;
}
.risk-stats {
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
}
.stat-mini {
    text-align: center;
}
.stat-number {
    font-size: 16px;
    font-weight: 700;
    color: #6c5ce7;
    display: block;
}
.stat-text {
    font-size: 9px;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 500;
}

.cadastral-section {
    background: #f8f9fa;
    //margin: 0 16px 12px 16px;
    border-radius: 12px;
    padding: 12px;
    border: 1px solid #e9ecef;
}

.building-details-content {
    padding: 12px;
}
.building-detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 10px;
}
.building-detail-item {
    background: white;
    border-radius: 4px;
    padding: 6px;
    text-align: center;
    border: 1px solid #f8f9fa;
}
.building-detail-label {
    font-size: 8px;
    color: #6c757d;
    margin-bottom: 2px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 500;
}
.building-detail-value {
    font-size: 11px;
    font-weight: 600;
    color: #343a40;
}
.dpe-badge {
    width: 18px;
    height: 18px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: 700;
    //font-family: serif;
    color: white;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}
.dpe-A {
    background: #38993f;
    color: #000;
    text-shadow: none;
}
.dpe-B {
    background: #3fcb4a;
    color: #000;
    text-shadow: none;
}
.dpe-C {
    background: #ceff59;
    color: #000;
    text-shadow: none;
}
.dpe-D {
    background: #ffff4c;
    color: #000;
    text-shadow: none;
}
.dpe-E {
    background: #fecd3e;
    color: #000;
    text-shadow: none;
}
.dpe-F {
    background: #fd9c46;
    color: #000;
    text-shadow: none;
}
.dpe-G {
    background: #fc1c19;
    color: #ffffff;
    text-shadow: none;
}

.btn-badge {
    background: #662bc3;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    position: relative;
    transition: all 0.3s ease;
}

.btn-badge .icon {
    width: 20px;
    height: 20px;
    fill: currentColor;
}
.btn-badge::after {
	content: "2 min";
	position: absolute;
	top: -8px;
	right: -8px;
	background: #f59e0b;
	color: white;
	border-radius: 12px;
	padding: 2px 8px;
	font-size: 12px;
	font-weight: 500;
}

.btn-badge:hover {
	background: #6d28d9;
	transform: scale(1.05);
}

</style>
